import React from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "reactstrap";
import "../scss/AuthLayout.css";
import Logo from "../images/logo/logo.svg";
import Imagen from "../images/auth2.jpg";
// import Imagen from "../images/imagen_log.png";
//"https://trato-plugin.s3.amazonaws.com/hero.png"

function AuthLayout({ children, title }) {
  return (
    <section>
      <div className="auth-container">
        <div className="auth-container__img">
          <img src={Imagen} alt="Image" />
        </div>
        <div className="auth-container__sign">
          <h2>{title}</h2>
          <div className="auth-container__child">{children}</div>
          <div className="auth-container__logo">
            <img src={Logo} alt="Logo" />
          </div>
        </div>
      </div>
    </section>
  );
}

AuthLayout.propTypes = {};

export default AuthLayout;
